// Shopify integration — frontend side.
//
// The page talks ONLY to our FastAPI backend (/api/shopify/*), which holds the
// private Storefront API token server-side. The customer pays on Shopify's
// hosted checkout (checkoutUrl returned by cartCreate). No payment details
// ever touch this site.
//
// Server config lives in backend/.env:
//   SHOPIFY_STORE_DOMAIN       e.g. your-store.myshopify.com
//   SHOPIFY_STOREFRONT_TOKEN   Storefront API access token
//
// Until a store domain is configured the backend answers `configured: false`
// and every button falls back to the placeholder product URL below.

export const PRODUCT_HANDLE = 'engine';

export const SHOPIFY_PRODUCT_URL =
    'https://engine-studio-copilot.myshopify.com/products/engine'; // PLACEHOLDER fallback until the store is connected
